import React, { useState, useEffect } from "react"
import Modal from "react-bootstrap/Modal"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import { Typography } from "@mui/material"
import { addTest, getAllTestRMO } from "../../../../core/services/api"
import Toast from "../../../Toast"
// import AddTest from "./AddTest"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { useSelector } from "react-redux"
import "./Tests.scss"
import TestResults from "./TestResults"
import { MocUserRole } from "core/services/models/Enums"
import { calculateAge } from "core/utils/date"

function Tests({ closePrintModal, patientIdRMO, patientMOC, appointmentDetails, smartSummaryData }: any) {

    const [show, setShow] = useState(true)
    const [response, setresponse] = useState({})
    const [displayToast, toggleDisplayToast] = useState<any>()
    const userRole = useSelector((state: any) => state?.user?.role)
    const [readOnly, setReadOnly] = useState<boolean>(false)

    useEffect(() => {
        //Tests to be enabled for RMO, Consultant, sub consultants
        const isReadOnly =
            (
                (
                    userRole === MocUserRole.RMO ||
                    userRole === MocUserRole.CONSULTANT
                ) ||
                (userRole === MocUserRole.GENETIC_COUNSELLOR) ||
                (userRole === MocUserRole.NUTRITIONIST) ||
                (userRole === MocUserRole.PHYSIOTHERAPIST) ||
                (userRole === MocUserRole.PSYCHOLOGIST)
            ) &&
                appointmentDetails?.isEditable &&
                appointmentDetails?.arrivalTime
                ? false
                : true
        setReadOnly(isReadOnly)
    }, [appointmentDetails])

    const handleClose = () => {
        setShow(false)
        closePrintModal(false)
    }

    //Tabs
    interface TabPanelProps {
        children?: React.ReactNode
        index: number
        value: number
    }

    const [value, setValue] = React.useState(0)

    useEffect(() => {
        fetchTestResults()
    }, [])

    function fetchTestResults() {
        getAllTestRMO({ patientId: patientIdRMO })
            .then((res: any) => {
                setresponse(res)
            })
            .catch((err: any) => {
                console.log("err", err)
            })
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    const handleSaveTestResults = (values: any, isDelete: any = false) => {
        addTest(values, patientIdRMO)
            .then((res: any) => {
                fetchTestResults()
                if (isDelete) {
                    toggleDisplayToast({
                        message: "Test details deleted successfully",
                        type: "success",
                    })
                } else {
                    toggleDisplayToast({
                        message: "Test results updated successfully",
                        type: "success",
                    })
                }
            })
            .catch((err: any) => {
                console.log(err?.message)
                toggleDisplayToast({
                    message: "Something went wrong, please try again.",
                    type: "error",
                })
            })
    }

    function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        )
    }

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        }
    }

    return (
        <div>
            <Modal className="tests-modal-wrapper" size="xl" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col className="basic-patient-details">
                                {PermissionUtils.displayPatientName(
                                    userRole,
                                    patientMOC,
                                    false,
                                    null,
                                    "-"
                                )}
                                {patientMOC?.mocId}-{patientMOC?.gender}-{calculateAge(patientMOC?.dob)}
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <>
                        {displayToast && (
                            <Toast
                                textMessage={displayToast?.message}
                                onClose={() => {
                                    toggleDisplayToast(false)
                                }}
                                onCloseText="Close"
                                onClickText={null}
                                type={displayToast?.type}
                            />
                        )}
                        {/* <Row className="heading-test">Test Results</Row> */}
                        <div className="search-add-print">
                            <div className="print-addNew">
                                <Box sx={{ width: "100%", marginTop: "20px" }}>
                                    <Box sx={{}}>
                                        <Tabs
                                            TabIndicatorProps={{
                                                sx: {
                                                    bgcolor: "blue",
                                                    height: "2px",
                                                    color: "blue",
                                                },
                                            }}
                                            value={value}
                                            onChange={handleChange}
                                            aria-label="basic tabs example"
                                        >
                                            <Tab
                                                sx={{
                                                    textTransform: "none",
                                                    fontSize: "20px",
                                                    fontWeight: "700",
                                                }}
                                                label="Test Results"
                                                {...a11yProps(0)}
                                            />
                                            {/* <Tab
                                                sx={{
                                                    textTransform: "none",
                                                    fontSize: "20px",
                                                    fontWeight: "700",
                                                }}
                                                label="Add Test"
                                                {...a11yProps(1)}
                                            /> */}
                                        </Tabs>
                                    </Box>
                                    <TabPanel value={value} index={0}>
                                        <TestResults
                                            response={response}
                                            handleSaveTestResults={handleSaveTestResults}
                                            readOnly={readOnly}
                                            patientInfo={patientMOC}
                                            smartSummaryData={smartSummaryData}
                                            appointmentDate={appointmentDetails?.scheduleDate}
                                        />
                                    </TabPanel>
                                    {/* <TabPanel value={value} index={1}>
                                        <AddTest  patientDetails={patientMOC}/>
                                    </TabPanel> */}
                                </Box>
                            </div>
                        </div>
                    </>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Tests